var _style, _path, _path2, _path3, _path4, _circle, _circle2, _circle3, _circle4, _circle5, _rect, _line, _rect2, _line2, _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStyle101(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 423 520",
    style: {
      enableBackground: "new 0 0 423 520"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st314{fill:#FFFFFF;stroke:#000000;stroke-width:3;stroke-miterlimit:10;}\n\t.st315{fill:#FFFFFF;stroke:#000000;stroke-miterlimit:10;}\n\t.st316{fill:none;stroke:#000000;stroke-miterlimit:10;}\n\t.st317{fill:#FFFFFF;stroke:#000000;stroke-width:0.8852;stroke-miterlimit:10;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st314",
    d: "M167,68.4c-0.8,1.5-1.2,3.3-1.2,5c0.2,9.6,15.1,18.8,36.7,23.8c0.2,4.6,0.7,10.1,0.9,14.7 c-2.9-0.8-25.4-0.4-35.2-12.7c-1.8-2.2-5.2-4.9-7.6-8.6c-1.2-1.9-4.7-4.8-4.4-9c0.3-4.5,4.4-8,5.4-9.3C163.2,70.8,165,69.4,167,68.4 z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st314",
    d: "M96.4,416.8l117.5,7.5c-1.3-104.2-2.6-208.5-3.9-312.7c-4.3,0.5-23.4,2.1-39.6-11.1 c-6.3-5.2-11.3-11.8-14.5-19.3l-44.9,23.8l-2,1.1h-0.1l-0.3,0.1v1.7c0.6,1.8,1.2,3.6,1.7,5.4c8.7,30.1,7.2,70.7,0.8,75.7 c-2.2,1.8-4.7,3.1-7.4,3.7c-1.7,0.4-3.5,0.6-5.2,0.8h-0.3l0,0l-1.4,0.1c0.6,2.2,1.1,4.5,1.7,6.8c1.2,5.6,2.3,11.4,3.2,17.4 c2.5,17.2,3.6,36.3,4.4,57.5C108.3,335,105.6,382.5,96.4,416.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st314",
    d: "M242.1,68.4c0.8,1.5,1.2,3.3,1.2,5c-0.2,9.6-15.1,18.8-36.7,23.7c-0.2,4.6-0.7,10.1-0.9,14.7 c2.9-0.8,25.4-0.4,35.2-12.7c1.8-2.2,5.2-4.9,7.6-8.6c1.2-1.9,4.7-4.8,4.4-9c-0.3-4.5-4.4-8-5.4-9.3C245.8,70.7,244,69.4,242.1,68.4 z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st314",
    d: "M312.6,416.8l-117.5,7.5c1.3-104.2,2.6-208.5,3.9-312.7c4.3,0.5,23.4,2.1,39.6-11.1 c6.3-5.2,11.3-11.8,14.5-19.3l44.9,23.8l2,1.1h0.1l0.3,0.1v1.7c-0.6,1.8-1.2,3.6-1.7,5.4c-8.7,30.1-7.2,70.7-0.8,75.7 c2.2,1.8,4.7,3.1,7.5,3.7c1.7,0.4,3.5,0.6,5.2,0.8h0.3l0,0l1.4,0.1c-0.6,2.2-1.1,4.5-1.7,6.8c-1.2,5.6-2.3,11.4-3.1,17.4 c-2.5,17.2-3.6,36.3-4.4,57.5C300.8,335,303.4,382.5,312.6,416.8z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207.7,
    cy: 273.2,
    r: 5.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.7,
    cy: 323.5,
    r: 5.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.7,
    cy: 122.4,
    r: 5.7
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.7,
    cy: 172.7,
    r: 5.7
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 207.7,
    cy: 222.9,
    r: 5.7
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 241.9,
    y: 313,
    className: "st315",
    width: 56.8,
    height: 4.4
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st316",
    x1: 261.2,
    y1: 232.3,
    x2: 259.3,
    y2: 313
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 110.6,
    y: 313.8,
    className: "st315",
    width: 56.8,
    height: 4.4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st316",
    x1: 148.1,
    y1: 233.1,
    x2: 149.9,
    y2: 313.8
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st317",
    points: "277.1,171.7 240.8,171.7 243.5,162.3 279.7,162.3 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyle101);
export default __webpack_public_path__ + "static/media/STYLE 1-01.3fc09df5a3fd5ff741c802403cbe9c02.svg";
export { ForwardRef as ReactComponent };